const shallowEqual = (a, b) => {
  if (a === b) return true;
  if (typeof a !== 'object' || typeof b !== 'object' || a == null || b == null) return false;
  const keysA = Object.keys(a);
  const keysB = Object.keys(b);
  if (keysA.length !== keysB.length) return false;
  return keysA.every(key => Object.prototype.hasOwnProperty.call(b, key) && a[key] === b[key]);
};

function createRateLimitedRunner(fn, delaySeconds = 5) {
  let lastRunTime = 0;
  let pendingTimeout = null;
  let lastValue;
  const delay = delaySeconds * 1000;

  const doRun = (value) => {
    lastRunTime = Date.now();
    lastValue = value;
    fn(value);
  };

  return {
    run(value) {
      // Clear any pending timeout
      if (pendingTimeout) {
        clearTimeout(pendingTimeout);
        pendingTimeout = null;
      }

      if (shallowEqual(value, lastValue)) return;

      const now = Date.now();
      const timeSinceLastLog = now - lastRunTime;

      if (timeSinceLastLog >= delay) {
        // Enough time has passed, log immediately
        doRun(value);
      } else {
        // Not enough time has passed, schedule a log
        const remainingTime = delay - timeSinceLastLog;
        pendingTimeout = setTimeout(() => {
          doRun(value);
          pendingTimeout = null;
        }, remainingTime);
      }
    },

    destroy() {
      if (pendingTimeout) {
        clearTimeout(pendingTimeout);
        pendingTimeout = null;
      }
    },
  };
}

export default createRateLimitedRunner;
